import { useLang } from "@/context/LanguageContext";
import { Globe } from "lucide-react";

export default function LanguageToggle({ className = "" }) {
  const { lang, toggle } = useLang();
  return (
    <button
      data-testid="language-toggle"
      onClick={toggle}
      aria-label={lang === "id" ? "Switch to English" : "Ganti ke Bahasa Indonesia"}
      className={`group inline-flex items-center gap-1.5 h-9 rounded-full border border-zinc-200 bg-white hover:border-zinc-400 px-3 text-xs font-semibold tracking-wide transition-colors ${className}`}
    >
      <Globe className="w-3.5 h-3.5 text-zinc-500 group-hover:text-brand transition-colors" />
      <span className={`transition-colors ${lang === "id" ? "text-zinc-900" : "text-zinc-400"}`}>ID</span>
      <span className="text-zinc-300">/</span>
      <span className={`transition-colors ${lang === "en" ? "text-zinc-900" : "text-zinc-400"}`}>EN</span>
    </button>
  );
}
